module.exports = __webpack_public_path__ + "img/SYM02.51acacfb.gif";